import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DiscountPipe } from './discount.pipe';

@NgModule({
  declarations: [DiscountPipe],
  imports: [CommonModule],
})
export class DiscountPipeModule {}
